
import { Users, FileText, DollarSign, BadgeDollarSign } from "lucide-react";
import { useAdminMetrics } from "@/hooks/useAdminMetrics";
import { MetricCard } from "./metrics/MetricCard";

const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

const formatNumber = (num: number) => {
  return new Intl.NumberFormat('en-US').format(num);
};

export const AdminMetrics = () => {
  const { data: metrics, isLoading, error } = useAdminMetrics();

  // Add console log to help with debugging
  console.log('Admin metrics data:', metrics);

  if (error) {
    console.error('Error loading admin metrics:', error);
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 3xl:grid-cols-4 gap-6">
      <MetricCard
        title="Total Users"
        value={formatNumber(metrics?.usersCount ?? 0)}
        icon={Users}
        iconColorClass="text-blue-600"
        iconBgClass="bg-blue-100"
        isLoading={isLoading}
      />

      <MetricCard
        title="Active Policies"
        value={formatNumber(metrics?.policiesCount ?? 0)}
        icon={FileText}
        iconColorClass="text-green-600"
        iconBgClass="bg-green-100"
        isLoading={isLoading}
      />

      <MetricCard
        title="Total Premiums (This Month)"
        value={formatCurrency(metrics?.totalPremiums ?? 0)}
        icon={DollarSign}
        iconColorClass="text-purple-600"
        iconBgClass="bg-purple-100"
        isLoading={isLoading}
      />

      <MetricCard
        title="Estimated Commissions (This Month)"
        value={formatCurrency(metrics?.estimatedCommissions ?? 0)}
        icon={BadgeDollarSign}
        iconColorClass="text-orange-600"
        iconBgClass="bg-orange-100"
        isLoading={isLoading}
      />
    </div>
  );
};
